export default __webpack_public_path__ + "static/media/plus-symbol.50ad15e1.svg";